import { NgModule } from '@angular/core';
import { FormatCurrencyPipe } from '../../pipes/currency.pipe';

@NgModule({
  exports: [FormatCurrencyPipe],
  declarations: [FormatCurrencyPipe],
  providers: [FormatCurrencyPipe],
})
export class CurrencyPipeModule {}
